import axios, {AxiosResponse} from 'axios';
import {handleError} from '../apis/errorHandling';

export interface ExchangeRateResponse {
    base: string;
    rates: {[currencyCode: string]: number};
}

export function getExchangeRate(): Promise<AxiosResponse<ExchangeRateResponse>> {
    return axios.get(`currency/rates`, {}).catch(handleError('error:loadingOfCurrencyExchangeRatesFailed'));
}



// WEBPACK FOOTER //
// ./src/currency/CurrencyAPI.ts